import { Component } from 'react'
import { Benefit, listBenefits } from '../../../../../insfrastructure/services/benefits'
import { ErrorMessage, emptyField, errorsLength, formatErrors } from '../../../../../insfrastructure/utils/form-validators'
import CheckboxInput from '../../../../components/checkbox'
import { Input } from '../../../../components/input'
import BenefitsList, { SelectedBenefit } from './benefits-list'
import moneyImg from '../../../../../assets/icons/money.svg'
import { logger } from '../../../../../insfrastructure/services/analytics'
import './styles.sass'

interface Props {
  inital_data?: any,
  onSubmit: (data: any) => void
}

export interface BenefitsForm {
  salary: number,
  comission: string,
  show_salary: boolean,
  benefits: SelectedBenefit[]
}

interface State {
    form: BenefitsForm,
    formErrors: Record<string, any>,
    benefit_options: Benefit[],
    show_new_benefit_form: boolean,
    new_benefit: Record<string, any>,
    new_benefit_form_errors:Record<string, any>
}

export default class Benefits extends Component<Props> {
  state: State = {
    form: {
      salary: 0,
      comission: '',
      show_salary: true,
      benefits: []
    },
    formErrors: {},
    benefit_options: [],
    show_new_benefit_form: false,
    new_benefit: {},
    new_benefit_form_errors: {}
  }

  componentDidMount() {
    if(this.props.inital_data) {
      this.setState({ form: {
        ...this.state.form,
        ...this.props.inital_data
      } });
    };

    this.listBenefits();

    if(this.props.inital_data.salary && this.state.form.salary === 0) {
      this.setState({ form: this.props.inital_data });
    };
  }

  listBenefits = async () => {
    try {  
      // Obter candidate_id do localStorage se disponível
      const candidate_id = localStorage.getItem('candidate_id');
      const benefit_options = (await listBenefits(candidate_id)).results;

      this.setState({ benefit_options });
    } catch (error) {
      logger.error('Erro ao carregar benefícios', error as Error);
    }
  }

  toggleBenefitForm = () => {
    this.setState({ show_new_benefit_form: !this.state.show_new_benefit_form, new_benefit: {} });
  }

  onSubmitBenefit = () => {
    const errors = formatErrors({
      name: [emptyField(this.state.new_benefit.name, 'string')]
    });

    this.setState({ new_benefit_form_errors: errors });

    if(errorsLength(errors) > 0) return;

    this.setState({ 
      benefit_options: [ ...this.state.benefit_options, { label: this.state.new_benefit.name, value: this.state.new_benefit.name } ], 
      show_new_benefit_form: false,
      new_benefit: null
    });
  }

  onSubmit = () => {
    const errors = formatErrors({
      salary: [emptyField(this.state.form.salary, 'string')],
      comission: [
        this.state.form.comission && this.state.form.comission.length > 60
          ? 'Garanta que este valor tenha no máximo 60 caracteres'
          : ''
      ]
    });

    this.setState({ formErrors: errors });

    if(errorsLength(errors) > 0) return;

    this.props.onSubmit(this.state.form);
  }

  render() {
    return (
      <div className='benefits'>
        <div className='salary-section'>
          <div className='wage-inputs'>
            <div className='wage-input-container'>
              <Input
              name='salary'
              type='money'
              label='Salário'
              placeholder='Ex: R$ 2.500,00'
              icon={moneyImg}
              value={this.state.form.salary}
              onChange={e => this.setState({ form: { ...this.state.form, salary: e } })}/>
              <ErrorMessage errors={this.state.formErrors['salary']} />
            </div>
            {/* <div className='wage-input-container'>
              <Select
              name='wage_range'
              label='Faixa Salárial'
              icon={moneyImg}
              value={this.state.form.wage_range}
              options={[
                {
                  value: 'Até R$ 1500',
                  label: 'Até R$ 1500'
                },
                {
                  value: 'Entre R$ 1501 e R$ 2000',
                  label: 'Entre R$ 1501 e R$ 2000'
                },
                {
                  value: 'Entre R$ 2001 e R$ 2500',
                  label: 'Entre R$ 2001 e R$ 2500'
                },
                {
                  value: 'Entre R$ 2501 e R$ 3000',
                  label: 'Entre R$ 2501 e R$ 3000'
                },
                {
                  value: 'Entre R$ 3001 e R$ 3500',
                  label: 'Entre R$ 3001 e R$ 3500'
                },
                {
                  value: 'Entre R$ 3501 e R$ 4000',
                  label: 'Entre R$ 3501 e R$ 4000'
                },
                {
                  value: 'Entre R$ 4001 e R$ 4500',
                  label: 'Entre R$ 4001 e R$ 4500'
                },
                {
                  value: 'Entre R$ 4501 e R$ 5000',
                  label: 'Entre R$ 4501 e R$ 5000'
                },
                {
                  value: 'Entre R$ 5001 e R$ 6000',
                  label: 'Entre R$ 5001 e R$ 6000'
                },
                {
                  value: 'Entre R$ 5001 e R$ 6000',
                  label: 'Entre R$ 5001 e R$ 6000'
                },
                {
                  value: 'Entre R$ 6001 e R$ 7000',
                  label: 'Entre R$ 6001 e R$ 7000'
                },
                {
                  value: 'Entre R$ 7001 e R$ 8000',
                  label: 'Entre R$ 7001 e R$ 8000'
                },
                {
                  value: 'Entre R$ 8001 e R$ 9000',
                  label: 'Entre R$ 8001 e R$ 9000'
                },
                {
                  value: 'Entre R$ 9001 e R$ 10000',
                  label: 'Entre R$ 9001 e R$ 10000'
                },
                {
                  value: 'Acima de R$ 10001',
                  label: 'Acima de R$ 10001'
                }
              ]}
              onChange={e => this.setState({ form: { ...this.state.form, wage_range: e } })}/>
              <ErrorMessage errors={this.state.formErrors['wage_range']} />
            </div> */}
            <div className='wage-input-container'>
              <Input
              name='comission'
              label='Comissão'
              placeholder='Ex: 5% sobre vendas ou R$ 500,00 fixo'
              value={this.state.form.comission}
              onChange={e => this.setState({ form: { ...this.state.form, comission: e } })}/>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '4px' }}>
                <small style={{ fontSize: '12px', color: (this.state.form.comission?.length || 0) > 60 ? '#D32F2F' : '#6B7280' }}>
                  {(this.state.form.comission?.length || 0)}/60
                </small>
              </div>
              <ErrorMessage errors={this.state.formErrors['comission']} />
            </div>
          </div>
          <CheckboxInput
          name='show_salary'
          label='Não exibir o salário no anúncio, apenas "a combinar"'
          checked={!this.state.form.show_salary}
          onChange={e => this.setState({ form: { ...this.state.form, show_salary: !e } })}/>
        </div>
        <div className='benefits-section'>
          <div className='benefits-section-header'>
            <h4>Benefícios</h4>
            <p>Se o campo de valor do benefício não for informado, o candidato visualizará como “valor do benefício: a combinar”</p>
          </div>
          <BenefitsList
          name='benefits'
          options={this.state.benefit_options}
          initialValue={this.state.form.benefits}
          onChange={e => this.setState({ form: { ...this.state.form, benefits: e } })}/>
          {this.state.show_new_benefit_form &&
          <div className='benefit-form'>
            <Input
            name='name'
            label='Nome'
            onChange={e => this.setState({ new_benefit: { ...this.state.new_benefit, name: e } })}/>
            <ErrorMessage errors={this.state.new_benefit_form_errors['name']} />
            <div className='columns'>
              <button className='secondary' onClick={this.onSubmitBenefit}>Salvar</button>
              <button className='cancel' onClick={this.toggleBenefitForm}>Cancelar</button>
            </div>
          </div>}
          {/* {!this.state.show_new_benefit_form &&
          <button className='secondary toggle-benefit-form' onClick={this.toggleBenefitForm}>
            <img src={addImg} alt='add-image' />
            <span>Adicionar Benefício</span>
          </button>} */}
        </div>
        <button className='primary' onClick={this.onSubmit}>Confirmar</button>
      </div>
    )
  }
}
